import { TierAwardImage } from "./TierAwardImage";

export function TierProgressView({description, title}: {description: string, title: string}) {
    return (
        <div className="relative flex flex-col gap-6 items-center justify-center">
            <TierAwardImage />
            <div className="flex flex-col gap-1 items-center mt-2">
                <span className="text-lg font-semibold leading-[27px] text-black">{title}</span>
                <span className="text-sm text-black">{description}</span>
            </div>
        </div>
    );
}
